import { useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import { apiFetch } from "../lib/api.js";

export default function Account() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function setPlan(plan) {
    setBusy(true);
    setError(null);
    try {
      await apiFetch("/account/dev-set-plan", { method: "POST", body: { plan } });
      await refresh();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="page">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        ACCOUNT
      </div>
      <h1 style={{ marginBottom: 8 }}>{user?.email}</h1>
      <p style={{ color: "var(--muted)", marginBottom: 32 }}>
        Plan: <span className="mono">{user?.plan}</span>
      </p>

      <div className="card">
        <div className="card-title" style={{ marginBottom: 8 }}>Development plan toggle</div>
        <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 16 }}>
          There is no checkout flow yet. This toggle only works outside production, for testing
          Premium features. In production, moving a real account to Premium is a manual internal
          step.
        </p>
        <div style={{ display: "flex", gap: 12 }}>
          <button className="btn-secondary" disabled={busy || user?.plan === "free"} onClick={() => setPlan("free")}>
            Set to free
          </button>
          <button className="btn-primary" disabled={busy || user?.plan === "paid"} onClick={() => setPlan("paid")}>
            Set to paid
          </button>
        </div>
        {error && <p style={{ color: "var(--error)", marginTop: 16 }}>{error}</p>}
      </div>
    </div>
  );
}
